import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { WorkflowForm } from 'app/models/workflow-form';

import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { FormGroup, FormArray } from '@angular/forms';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { AddEditWorkflowFormComponent } from '../add-edit-workflow-form/add-edit-workflow-form.component';
import { formGroupPatchValueNullFriendly } from 'app/helpers/utils';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-manage-forms',
  templateUrl: './manage-forms.component.html',
  styleUrls: ['./manage-forms.component.scss']
})
export class ManageFormsComponent implements OnInit {
  
  @Input() workflowStepCompletionFormGroup: FormGroup;
  @Input() formsErrors: any[];
  @Input() parentsForms: WorkflowForm[] = [];
  @Input() enableDuplicateFormOption: boolean = false;

  @ViewChild('addEditWorkflowForm', { static: true }) addEditWorkflowForm: AddEditWorkflowFormComponent;
  @ViewChild('deleteConfirmationModal', { static: true }) deleteConfirmationModal: ModalDirective;
  @ViewChild('formInUseModal', { static: true }) formInUseModal: ModalDirective;

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedFormsTableLimit: number = 100;
  
  editFormIndex: number = -1;
  editFormOldName: string = '';

  deleteFormIndex: number = -1;
  formToDelete: WorkflowForm = null;  

  formUsedIn: string[] = [];

  constructor(private workflowWizardService: WorkflowWizardService, private workflowTemplateService: WorkflowTemplateService) {
    
  }

  ngOnInit() {
  }
  
  deleteForm() {
    this.workflowWizardService.removeFormFromRules(this.formToDelete, this.workflowStepCompletionFormGroup);

    let formsFormArray: FormArray = (this.workflowStepCompletionFormGroup.controls['forms'] as FormArray);
    formsFormArray.removeAt(this.deleteFormIndex);
  }

  checkFormToDelete() {
    this.formUsedIn = this.workflowWizardService.isFormUsedInWorkflow(this.formToDelete.name, this.workflowStepCompletionFormGroup);

    if (this.formUsedIn) {
      this.formInUseModal.show();
    } else {
      this.deleteConfirmationModal.show();
    }
  }

  editForm(form: WorkflowForm, index: number) {
    this.editFormOldName = form.name;
    this.editFormIndex = index;
    
    let frmGroup: FormGroup = this.workflowTemplateService.getWorkflowFormFormGroup(form, this.workflowStepCompletionFormGroup);
    formGroupPatchValueNullFriendly(frmGroup, form);
    this.addEditWorkflowForm.show(frmGroup, true);
  }

  addNewForm() {
    this.editFormIndex = -1;
    let frmGroup: FormGroup = this.workflowTemplateService.getWorkflowFormFormGroup({} as WorkflowForm, this.workflowStepCompletionFormGroup);
    this.addEditWorkflowForm.show(frmGroup, false);
  }
  innerWidth() {
    return window.innerWidth;
  }

  onAddEditFinished(frm: FormGroup) {
    let formsFormArray: FormArray = (this.workflowStepCompletionFormGroup.controls['forms'] as FormArray);

    if (this.editFormIndex != -1) {
      formGroupPatchValueNullFriendly(formsFormArray.at(this.editFormIndex) as FormGroup, frm.value);
      let newFormName: string = frm.controls['name'].value;
      if (this.editFormOldName != newFormName) {
        this.workflowWizardService.renameFormInRules(this.editFormOldName, newFormName, this.workflowStepCompletionFormGroup);
      }
      this.editFormIndex = -1;
    } else {
      formsFormArray.push(frm);
      frm.setParent(formsFormArray);
    }
  }

  /// @TODO
  // hasError(formId){
  //   if(this.formsErrors.length > 0)
  //     return this.formsErrors.find(x => x.id == formId);
      
  //   return false;
  // }
}
